import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

function Header({ cartItems, onCartClick }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="main-header">
      {/* Logo */}
      <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
        <img src="/images/Samverkan-Logo.svg" alt="Samverkan Logo" />
      </Link>

      {/* Hamburger menu (mobile only) */}
      <button
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
      </button>

      {/* Navigation */}
      <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setMenuOpen(false)}>
          <img src="/images/icon-home.svg" alt="Home" />
        </Link>
        <Link to="/about" onClick={() => setMenuOpen(false)}>
          <img src="/images/icon-aboutus.svg" alt="About" />
        </Link>
        <Link to="/contact" onClick={() => setMenuOpen(false)}>
          <img src="/images/icon-contactus.svg" alt="Contact" />
        </Link>
        <button
          onClick={() => {
            onCartClick();
            setMenuOpen(false);
          }}
          className="cart-icon"
        >
          <img src="/images/icon-cart.svg" alt="Cart" />
          {cartItems.length > 0 && (
            <span className="cart-count">{cartItems.length}</span>
          )}
        </button>
      </nav>
    </header>
  );
}

export default Header;